import type { LandingConfig } from "../components/SeoLandingPage";

/* C4 round 1 (2026-10-30): the 9 graha mahadasha pages. Vimshottari years
   are classical constants (Ketu 7, Shukra 20, Surya 6, Chandra 10, Mangal 7,
   Rahu 18, Guru 16, Shani 19, Budh 17 = 120). Every antardasha duration is
   COMPUTED exactly as maha_years x antar_years / 120 and rounded to months,
   so the tables are verifiable arithmetic, not copied claims. Prose is
   classical interpretation framed with both sides (strong vs afflicted),
   never doom, never guarantees. */

export const ketuMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/ketu-mahadasha",
  "wide": true,
  "title": "Ketu Mahadasha: 7 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Ketu (Ketu) mahadasha Vimshottari me 7 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Ketu Mahadasha",
  "h1Pre": "Ketu Mahadasha:",
  "h1Accent": "7 saal ka adhyay",
  "sub": "Ketu (Ketu) ki mahadasha vairagya, moksha, antarmukh yatra ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Ketu ki mahadasha 7 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Ketu ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 7 saal",
    "Karak: vairagya",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Ketu mahadasha ka phal",
      "body": [
        "Ketu mahadasha 7 saal ki hoti hai aur sabse rahasyamayi maani jaati hai. Ketu moksha-karak hai: iski dasha bahar ki daud se zyada bheetar ki yatra ki dasha hai. Adhyatm, research, aur ekant ke vishay is daur me swabhavik roop se aate hain.",
        "Vyavaharik jeevan me Ketu dasha kabhi-kabhi dishahanta jaisi lagti hai, cheezein chhootti hain, aur naya raasta turant nahi dikhta. Classical drishti me yeh chhootna hi iska kaam hai: jo zaroori nahi tha, Ketu use hata deta hai. Is dasha me dhyan, seva aur guru ka margdarshan sabse bade sahare bataye gaye hain."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Ketu mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Ketu ki antardasha se hoti hai. Ketu mahadasha (7 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Ketu (Ketu)",
            "0 saal 5 mahine"
          ],
          [
            "Shukra (Venus)",
            "1 saal 2 mahine"
          ],
          [
            "Surya (Sun)",
            "0 saal 4 mahine"
          ],
          [
            "Chandra (Moon)",
            "0 saal 7 mahine"
          ],
          [
            "Mangal (Mars)",
            "0 saal 5 mahine"
          ],
          [
            "Rahu (Rahu)",
            "1 saal 1 mahine"
          ],
          [
            "Guru (Jupiter)",
            "0 saal 11 mahine"
          ],
          [
            "Shani (Saturn)",
            "1 saal 1 mahine"
          ],
          [
            "Budh (Mercury)",
            "1 saal"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Ketu dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Ketu mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Ketu ki mahadasha 7 saal ki hoti hai. Iski pehli antardasha khud Ketu ki hoti hai."
    },
    {
      "q": "Kya Ketu mahadasha me career kharab ho jaata hai?",
      "a": "Zaroori nahi. Ketu ki dasha focus badalti hai, research, adhyatm aur specialised kaam me log isi dasha me shikhar par pahunche hain. Haan, dikhawa aur bhaag-daud waale kaamon me mann kam lagta hai."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Ketu Mahadasha",
  "schemaDescription": "Ketu (Ketu) mahadasha in Vimshottari lasts 7 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const shukraMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/shukra-mahadasha",
  "wide": true,
  "title": "Shukra Mahadasha: 20 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Shukra (Venus) mahadasha Vimshottari me 20 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Shukra Mahadasha",
  "h1Pre": "Shukra Mahadasha:",
  "h1Accent": "20 saal ka adhyay",
  "sub": "Shukra (Venus) ki mahadasha prem, vivah, kala, sukh aur vaibhav ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Shukra ki mahadasha 20 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Shukra ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 20 saal",
    "Karak: prem",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Shukra mahadasha ka phal",
      "body": [
        "Shukra mahadasha Vimshottari ki sabse lambi shubh dasha hai: pure 20 saal. Shukra prem, vivah, kala, sundarta aur bhog ka karak hai, aur balvaan Shukra ki dasha jeevan me sukh, sampatti, vahan, aur rishton ki madhurta laati hui batayi gayi hai.",
        "Iska doosra pehlu bhi utna hi asli hai: peedit Shukra ki dasha me rishton ke uljhan, atirikt bhog aur kharch ki aadat aa sakti hai. 20 saal lambi dasha me sanyam hi asli dhan ban jaata hai. Kala, design, entertainment aur luxury se jude kaamon ke liye yeh dasha classical roop se sabse anukool maani jaati hai."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Shukra mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Shukra ki antardasha se hoti hai. Shukra mahadasha (20 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Shukra (Venus)",
            "3 saal 4 mahine"
          ],
          [
            "Surya (Sun)",
            "1 saal"
          ],
          [
            "Chandra (Moon)",
            "1 saal 8 mahine"
          ],
          [
            "Mangal (Mars)",
            "1 saal 2 mahine"
          ],
          [
            "Rahu (Rahu)",
            "3 saal"
          ],
          [
            "Guru (Jupiter)",
            "2 saal 8 mahine"
          ],
          [
            "Shani (Saturn)",
            "3 saal 2 mahine"
          ],
          [
            "Budh (Mercury)",
            "2 saal 10 mahine"
          ],
          [
            "Ketu (Ketu)",
            "1 saal 2 mahine"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Shukra dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Shukra mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Shukra ki mahadasha 20 saal ki hoti hai. Iski pehli antardasha khud Shukra ki hoti hai."
    },
    {
      "q": "Shukra mahadasha kiske liye sabse acchi hoti hai?",
      "a": "Jinke chart me Shukra balvaan ho, khaaskar Tula ya Vrishabh lagna/rashi waalon ke liye, aur kala, design, media ya vilasita se jude kshetron me kaam karne waalon ke liye."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Shukra Mahadasha",
  "schemaDescription": "Shukra (Venus) mahadasha in Vimshottari lasts 20 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const suryaMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/surya-mahadasha",
  "wide": true,
  "title": "Surya Mahadasha: 6 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Surya (Sun) mahadasha Vimshottari me 6 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Surya Mahadasha",
  "h1Pre": "Surya Mahadasha:",
  "h1Accent": "6 saal ka adhyay",
  "sub": "Surya (Sun) ki mahadasha atma-vishwas, pita, sarkar aur pratishtha ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Surya ki mahadasha 6 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Surya ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 6 saal",
    "Karak: atma-vishwas",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Surya mahadasha ka phal",
      "body": [
        "Surya mahadasha sabse chhoti mahadasha hai: 6 saal. Surya atma, pita, sarkar aur pratishtha ka karak hai. Balvaan Surya ki dasha me netritva, sarkari kaam, promotion aur samman ke yog classical roop se bataye gaye hain.",
        "Peedit Surya ahankar, pita se matbhed aur adhikariyon se tanaav de sakta hai. Chhoti dasha hai, isliye iske phal tez aur saaf dikhte hain: jo vinamrata ke saath netritva karta hai, Surya use roshni deta hai."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Surya mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Surya ki antardasha se hoti hai. Surya mahadasha (6 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Surya (Sun)",
            "0 saal 4 mahine"
          ],
          [
            "Chandra (Moon)",
            "0 saal 6 mahine"
          ],
          [
            "Mangal (Mars)",
            "0 saal 4 mahine"
          ],
          [
            "Rahu (Rahu)",
            "0 saal 11 mahine"
          ],
          [
            "Guru (Jupiter)",
            "0 saal 10 mahine"
          ],
          [
            "Shani (Saturn)",
            "0 saal 11 mahine"
          ],
          [
            "Budh (Mercury)",
            "0 saal 10 mahine"
          ],
          [
            "Ketu (Ketu)",
            "0 saal 4 mahine"
          ],
          [
            "Shukra (Venus)",
            "1 saal"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Surya dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Surya mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Surya ki mahadasha 6 saal ki hoti hai. Iski pehli antardasha khud Surya ki hoti hai."
    },
    {
      "q": "Surya mahadasha me kaunse kshetra aage badhte hain?",
      "a": "Sarkari seva, netritva ki bhoomikayein, administration aur aise kaam jahan vyakti ko samne aakar zimmedari leni hoti hai."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Surya Mahadasha",
  "schemaDescription": "Surya (Sun) mahadasha in Vimshottari lasts 6 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const chandraMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/chandra-mahadasha",
  "wide": true,
  "title": "Chandra Mahadasha: 10 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Chandra (Moon) mahadasha Vimshottari me 10 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Chandra Mahadasha",
  "h1Pre": "Chandra Mahadasha:",
  "h1Accent": "10 saal ka adhyay",
  "sub": "Chandra (Moon) ki mahadasha mann, bhavnayein, maa aur jan-sampark ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Chandra ki mahadasha 10 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Chandra ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 10 saal",
    "Karak: mann",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Chandra mahadasha ka phal",
      "body": [
        "Chandra mahadasha 10 saal ki hoti hai. Chandrama mann ka karak hai, isliye yeh dasha bhavnaon ki dasha hai: ghar-parivaar, maa, jan-sampark aur lokpriyata ke vishay samne aate hain. Balvaan Chandra ki dasha me man shaant, rishte gehre aur public-facing kaam safal hote hain.",
        "Ksheen ya peedit Chandra (jaise Amavasya ke paas janma, ya Shani-Rahu se drishta) ki dasha me mann ki asthirta, chinta aur nind ke vishay ubhar sakte hain. Is dasha ka sutra hai: mann ko sambhalo, baaki sambhal jaata hai. Dhyan, jal ke paas samay, aur maa ke saath sambandh is dasha ke classical upay hain."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Chandra mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Chandra ki antardasha se hoti hai. Chandra mahadasha (10 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Chandra (Moon)",
            "0 saal 10 mahine"
          ],
          [
            "Mangal (Mars)",
            "0 saal 7 mahine"
          ],
          [
            "Rahu (Rahu)",
            "1 saal 6 mahine"
          ],
          [
            "Guru (Jupiter)",
            "1 saal 4 mahine"
          ],
          [
            "Shani (Saturn)",
            "1 saal 7 mahine"
          ],
          [
            "Budh (Mercury)",
            "1 saal 5 mahine"
          ],
          [
            "Ketu (Ketu)",
            "0 saal 7 mahine"
          ],
          [
            "Shukra (Venus)",
            "1 saal 8 mahine"
          ],
          [
            "Surya (Sun)",
            "0 saal 6 mahine"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Chandra dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Chandra mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Chandra ki mahadasha 10 saal ki hoti hai. Iski pehli antardasha khud Chandra ki hoti hai."
    },
    {
      "q": "Chandra mahadasha me kya dhyaan rakhein?",
      "a": "Mann ki sthirta. Nind ka niyam, dhyan, aur bhavnatmak faislon ko ek raat rok kar lena, yeh teen aadatein is dasha ko sundar bana deti hain."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Chandra Mahadasha",
  "schemaDescription": "Chandra (Moon) mahadasha in Vimshottari lasts 10 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const mangalMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/mangal-mahadasha",
  "wide": true,
  "title": "Mangal Mahadasha: 7 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Mangal (Mars) mahadasha Vimshottari me 7 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Mangal Mahadasha",
  "h1Pre": "Mangal Mahadasha:",
  "h1Accent": "7 saal ka adhyay",
  "sub": "Mangal (Mars) ki mahadasha urja, sahas, bhoomi aur pratispardha ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Mangal ki mahadasha 7 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Mangal ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 7 saal",
    "Karak: urja",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Mangal mahadasha ka phal",
      "body": [
        "Mangal mahadasha 7 saal ki chhoti par tez dasha hai. Mangal urja, sahas, bhoomi-sampatti aur pratispardha ka karak hai: iski dasha me himmat ke kaam, sports, surakshabal, engineering aur zameen se jude vishay aage aate hain.",
        "Peedit Mangal krodh, jaldbazi, chot aur vivad de sakta hai, isi liye is dasha me sabse keemti gun sanyam hai. Urja ko disha mil jaaye to Mangal ke 7 saal me vyakti woh kar leta hai jo doosri dashaon me 15 saal maangta."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Mangal mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Mangal ki antardasha se hoti hai. Mangal mahadasha (7 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Mangal (Mars)",
            "0 saal 5 mahine"
          ],
          [
            "Rahu (Rahu)",
            "1 saal 1 mahine"
          ],
          [
            "Guru (Jupiter)",
            "0 saal 11 mahine"
          ],
          [
            "Shani (Saturn)",
            "1 saal 1 mahine"
          ],
          [
            "Budh (Mercury)",
            "1 saal"
          ],
          [
            "Ketu (Ketu)",
            "0 saal 5 mahine"
          ],
          [
            "Shukra (Venus)",
            "1 saal 2 mahine"
          ],
          [
            "Surya (Sun)",
            "0 saal 4 mahine"
          ],
          [
            "Chandra (Moon)",
            "0 saal 7 mahine"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Mangal dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Mangal mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Mangal ki mahadasha 7 saal ki hoti hai. Iski pehli antardasha khud Mangal ki hoti hai."
    },
    {
      "q": "Mangal mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari me Mangal ki mahadasha 7 saal ki hoti hai, aur iski pehli antardasha Mangal ki apni hoti hai."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Mangal Mahadasha",
  "schemaDescription": "Mangal (Mars) mahadasha in Vimshottari lasts 7 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const rahuMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/rahu-mahadasha",
  "wide": true,
  "title": "Rahu Mahadasha: 18 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Rahu (Rahu) mahadasha Vimshottari me 18 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Rahu Mahadasha",
  "h1Pre": "Rahu Mahadasha:",
  "h1Accent": "18 saal ka adhyay",
  "sub": "Rahu (Rahu) ki mahadasha ambition, videsh, technology aur achanak badlav ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Rahu ki mahadasha 18 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Rahu ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 18 saal",
    "Karak: ambition",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Rahu mahadasha ka phal",
      "body": [
        "Rahu mahadasha 18 saal chalti hai aur apne naam ke anuroop hi chalti hai: tezi se upar le jaane waali, par disha ki maang karti hui. Classical granth Rahu ko chhaya-grah kehte hain, iske paas apna ghar nahi, isliye yeh jis ghar aur rashi me baitha hai usी ka roop le leta hai. Isi se Rahu dasha ke phal itne alag-alag hote hain.",
        "Achhi sthiti ka Rahu videsh yatra, technology, media aur bade pablik platforms ke dwar kholta hai; ambition ko pankh deta hai. Peedit Rahu bhram, galat sangati aur shortcut ki aadat de sakta hai. Is dasha me sabse zaroori cheez hai grounding: jo vyakti apne niyam aur neev pakad kar rakhta hai, uske liye Rahu ke 18 saal zindagi ke sabse bade visthaar ke saal ban jaate hain."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Rahu mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Rahu ki antardasha se hoti hai. Rahu mahadasha (18 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Rahu (Rahu)",
            "2 saal 8 mahine"
          ],
          [
            "Guru (Jupiter)",
            "2 saal 5 mahine"
          ],
          [
            "Shani (Saturn)",
            "2 saal 10 mahine"
          ],
          [
            "Budh (Mercury)",
            "2 saal 7 mahine"
          ],
          [
            "Ketu (Ketu)",
            "1 saal 1 mahine"
          ],
          [
            "Shukra (Venus)",
            "3 saal"
          ],
          [
            "Surya (Sun)",
            "0 saal 11 mahine"
          ],
          [
            "Chandra (Moon)",
            "1 saal 6 mahine"
          ],
          [
            "Mangal (Mars)",
            "1 saal 1 mahine"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Rahu dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Rahu mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Rahu ki mahadasha 18 saal ki hoti hai. Iski pehli antardasha khud Rahu ki hoti hai."
    },
    {
      "q": "Rahu mahadasha me kya savdhani rakhein?",
      "a": "Bhram aur shortcut se bachna sabse badi savdhani hai. Bade financial faisle do baar jaanch kar lijiye, aur sangati ka vishesh dhyaan rakhiye. Rahu visthaar deta hai, disha aapko khud rakhni hoti hai."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Rahu Mahadasha",
  "schemaDescription": "Rahu (Rahu) mahadasha in Vimshottari lasts 18 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const guruMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/guru-mahadasha",
  "wide": true,
  "title": "Guru Mahadasha: 16 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Guru (Jupiter) mahadasha Vimshottari me 16 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Guru Mahadasha",
  "h1Pre": "Guru Mahadasha:",
  "h1Accent": "16 saal ka adhyay",
  "sub": "Guru (Jupiter) ki mahadasha gyaan, dharma, santaan aur samriddhi ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Guru ki mahadasha 16 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Guru ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 16 saal",
    "Karak: gyaan",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Guru mahadasha ka phal",
      "body": [
        "Guru (Brihaspati) mahadasha 16 saal ki hoti hai aur parampara me ise sabse shubh dashaon me gina jaata hai. Guru gyaan, dharma, guru-jan, santaan aur dhan ka karak hai; iski dasha me vivah, santaan-prapti, shiksha aur samman ke yog classical roop se bataye gaye hain.",
        "Phir bhi, 'Guru dasha matlab sab accha' maan lena bhool hai: neech ka ya peedit Guru atirikt aatmavishwas, aalasya aur adhoore vaade de sakta hai. Balvaan Guru waale chart me yeh 16 saal jeevan ke sabse santulit aur samriddh saal hote hain, vistaar bhi, aur use sambhalne ki buddhi bhi."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Guru mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Guru ki antardasha se hoti hai. Guru mahadasha (16 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Guru (Jupiter)",
            "2 saal 2 mahine"
          ],
          [
            "Shani (Saturn)",
            "2 saal 6 mahine"
          ],
          [
            "Budh (Mercury)",
            "2 saal 3 mahine"
          ],
          [
            "Ketu (Ketu)",
            "0 saal 11 mahine"
          ],
          [
            "Shukra (Venus)",
            "2 saal 8 mahine"
          ],
          [
            "Surya (Sun)",
            "0 saal 10 mahine"
          ],
          [
            "Chandra (Moon)",
            "1 saal 4 mahine"
          ],
          [
            "Mangal (Mars)",
            "0 saal 11 mahine"
          ],
          [
            "Rahu (Rahu)",
            "2 saal 5 mahine"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Guru dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Guru mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Guru ki mahadasha 16 saal ki hoti hai. Iski pehli antardasha khud Guru ki hoti hai."
    },
    {
      "q": "Kya Guru mahadasha me shaadi ke yog bante hain?",
      "a": "Classical roop se haan, Guru vivah aur santaan ka pramukh karak hai, aur iski dasha-antardasha me yeh ghatnaayein aam taur par batayi jaati hain. Par timing aapke 7th house, uske swami aur navamsa par bhi depend karti hai."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Guru Mahadasha",
  "schemaDescription": "Guru (Jupiter) mahadasha in Vimshottari lasts 16 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const shaniMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/shani-mahadasha",
  "wide": true,
  "title": "Shani Mahadasha: 19 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Shani (Saturn) mahadasha Vimshottari me 19 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Shani Mahadasha",
  "h1Pre": "Shani Mahadasha:",
  "h1Accent": "19 saal ka adhyay",
  "sub": "Shani (Saturn) ki mahadasha discipline, karma aur dheemi par pakki tarakki ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Shani ki mahadasha 19 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Shani ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 19 saal",
    "Karak: discipline",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Shani mahadasha ka phal",
      "body": [
        "Shani mahadasha Vimshottari ki sabse lambi dasha hai: 19 saal. Iska naam sunte hi log darr jaate hain, par classical jyotish me Shani ko karma ka nyayadheesh kaha gaya hai, woh wahi deta hai jo aapke karm ne banaya hai. Jinke chart me Shani balvaan aur shubh sthiti me hai, unke liye yeh dasha career ki sabse thos tarakki, zameen-jaayedaad aur adhikar ke saal laati hai.",
        "Kathinai tab aati hai jab Shani chart me peedit ho: der se phal, zimmedariyon ka bojh, aur mehnat ke mukable dheema inaam. Par pattern ek hi hai, Shani shortcut kaatta hai aur system banata hai. Jo is dasha me anushasan, niyam aur seva apnaata hai, uske liye 19 saal ka yeh daur neev ban jaata hai jis par baaki zindagi tiki rehti hai."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Shani mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Shani ki antardasha se hoti hai. Shani mahadasha (19 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Shani (Saturn)",
            "3 saal"
          ],
          [
            "Budh (Mercury)",
            "2 saal 8 mahine"
          ],
          [
            "Ketu (Ketu)",
            "1 saal 1 mahine"
          ],
          [
            "Shukra (Venus)",
            "3 saal 2 mahine"
          ],
          [
            "Surya (Sun)",
            "0 saal 11 mahine"
          ],
          [
            "Chandra (Moon)",
            "1 saal 7 mahine"
          ],
          [
            "Mangal (Mars)",
            "1 saal 1 mahine"
          ],
          [
            "Rahu (Rahu)",
            "2 saal 10 mahine"
          ],
          [
            "Guru (Jupiter)",
            "2 saal 6 mahine"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Shani dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Shani mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Shani ki mahadasha 19 saal ki hoti hai. Iski pehli antardasha khud Shani ki hoti hai."
    },
    {
      "q": "Kya Shani mahadasha hamesha kharab hoti hai?",
      "a": "Nahi. Yeh chart par depend karta hai: balvaan aur shubh Shani ke liye yeh career aur adhikar ki sabse majboot dasha ho sakti hai. Peedit Shani ke saal mehnat zyada maangte hain aur phal der se dete hain, par dete zaroor hain."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Shani Mahadasha",
  "schemaDescription": "Shani (Saturn) mahadasha in Vimshottari lasts 19 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const budhMahadasha: LandingConfig = {
  "url": "https://astroaura.ai/budh-mahadasha",
  "wide": true,
  "title": "Budh Mahadasha: 17 Saal Ka Phal Aur Antardasha | Aura AI",
  "description": "Budh (Mercury) mahadasha Vimshottari me 17 saal chalti hai. Iska phal, antardasha ka pura krama aur samay, aur apni current dasha free check karne ka tarika.",
  "eyebrow": "Budh Mahadasha",
  "h1Pre": "Budh Mahadasha:",
  "h1Accent": "17 saal ka adhyay",
  "sub": "Budh (Mercury) ki mahadasha buddhi, vyapar, communication aur shiksha ka daur hai. Yahan iska classical phal, antardasha ka pura table, aur yeh janne ka free tarika ki aap par yeh dasha kab chal rahi hai.",
  "primaryCta": "Apni current dasha free check kijiye",
  "secondaryCta": "Free kundli banaiye",
  "lede": [
    "Vimshottari dasha paddhati me Budh ki mahadasha 17 saal ki hoti hai. Yeh page iska classical phal, antardasha ka pura krama (exact samay ke saath), aur aapke apne chart me is dasha ko dekhne ka tarika batata hai. Dasha ka asli phal hamesha aapke chart me Budh ki sthiti par depend karta hai, isliye generic bhavishyavani se zyada apna chart dekhna kaam aata hai."
  ],
  "heroFacts": [
    "Avadhi: 17 saal",
    "Karak: buddhi",
    "Paddhati: Vimshottari"
  ],
  "sections": [
    {
      "h2": "Budh mahadasha ka phal",
      "body": [
        "Budh mahadasha 17 saal ki hoti hai. Budh buddhi, vaani, ganit, lekhan aur vyapar ka karak hai, isliye iski dasha ko vidya aur business ki dasha kaha jaata hai. Balvaan Budh ke saal naye hunar, nayi degree, naye vyapar aur networking ke saal hote hain.",
        "Budh chanchal grah hai: peedit hone par bikhrav, adhoore project aur vaani ke dosh (bol kar phas jaana) de sakta hai. Is dasha me focus hi siddhi hai, ek samay me ek kaam poora karne waale ke liye Budh ke 17 saal compounding ki tarah kaam karte hain."
      ],
      "chips": [
        {
          "to": "/mahadasha-calculator",
          "label": "Mahadasha calculator"
        },
        {
          "to": "/free-kundli",
          "label": "Free kundli"
        },
        {
          "to": "/talk-to-astrologer",
          "label": "AI jyotishi se poochhiye"
        }
      ]
    },
    {
      "h2": "Budh mahadasha me antardasha ka krama",
      "body": [
        "Har mahadasha ke andar navon grahon ki antardashayein aati hain, shuruaat khud Budh ki antardasha se hoti hai. Budh mahadasha (17 saal) ke andar har antardasha ka classical samay yeh hai (Vimshottari ganit: mahadasha varsh × antar-graha varsh ÷ 120):"
      ],
      "table": {
        "head": [
          "Antardasha",
          "Avadhi"
        ],
        "rows": [
          [
            "Budh (Mercury)",
            "2 saal 5 mahine"
          ],
          [
            "Ketu (Ketu)",
            "1 saal"
          ],
          [
            "Shukra (Venus)",
            "2 saal 10 mahine"
          ],
          [
            "Surya (Sun)",
            "0 saal 10 mahine"
          ],
          [
            "Chandra (Moon)",
            "1 saal 5 mahine"
          ],
          [
            "Mangal (Mars)",
            "1 saal"
          ],
          [
            "Rahu (Rahu)",
            "2 saal 7 mahine"
          ],
          [
            "Guru (Jupiter)",
            "2 saal 3 mahine"
          ],
          [
            "Shani (Saturn)",
            "2 saal 8 mahine"
          ]
        ],
        "caption": "Exact tithiyan aapke janm-samay par depend karti hain; apna personal timeline mahadasha calculator me dekhiye."
      }
    },
    {
      "h2": "Aap par yeh dasha kab chal rahi hai?",
      "body": [
        "Dasha ka krama janm ke samay Chandrama ke nakshatra se shuru hota hai, isliye do logon ki Budh dasha alag-alag umra me aati hai. Apni current mahadasha-antardasha aur unke end-dates free dekhne ke liye mahadasha calculator use kijiye, sirf janm ki date, samay aur jagah chahiye. Phir usi chart par AI jyotishi se poochh sakte hain ki aapke liye is dasha ka vishesh matlab kya hai."
      ]
    }
  ],
  "faqs": [
    {
      "q": "Budh mahadasha kitne saal ki hoti hai?",
      "a": "Vimshottari paddhati me Budh ki mahadasha 17 saal ki hoti hai. Iski pehli antardasha khud Budh ki hoti hai."
    },
    {
      "q": "Kya Budh mahadasha business ke liye acchi hai?",
      "a": "Classical roop se haan, Budh vyapar ka karak hai. Par chart me Budh ki sthiti dekhna zaroori hai: balvaan Budh calculated growth deta hai, peedit Budh bikhre huye kaam."
    },
    {
      "q": "Meri current dasha kaunsi hai?",
      "a": "Janm ki exact date, samay aur jagah se Vimshottari timeline nikalti hai. Aura AI ke free mahadasha calculator me yeh turant dikh jaata hai, mahadasha, antardasha aur unke end-dates ke saath."
    }
  ],
  "schemaName": "Budh Mahadasha",
  "schemaDescription": "Budh (Mercury) mahadasha in Vimshottari lasts 17 years. Classical results, full antardasha sequence with durations, and how to check your current dasha free.",
  "finalHeading": "Apna dasha-timeline free dekhiye",
  "finalText": "Date, samay aur jagah daaliye, aur apni current mahadasha-antardasha turant janiye.",
  "articleSection": "Jyotish Glossary",
  "disclaimer": "Dasha-phal classical jyotish ki vyakhya hai, guidance ke liye hai; yeh medical, legal ya financial salah ka vikalp nahi hai."
};

export const mahadashaPages: { path: string; config: LandingConfig }[] = [
  { path: "/ketu-mahadasha", config: ketuMahadasha },
  { path: "/shukra-mahadasha", config: shukraMahadasha },
  { path: "/surya-mahadasha", config: suryaMahadasha },
  { path: "/chandra-mahadasha", config: chandraMahadasha },
  { path: "/mangal-mahadasha", config: mangalMahadasha },
  { path: "/rahu-mahadasha", config: rahuMahadasha },
  { path: "/guru-mahadasha", config: guruMahadasha },
  { path: "/shani-mahadasha", config: shaniMahadasha },
  { path: "/budh-mahadasha", config: budhMahadasha },
];
